import { ref } from 'vue';
import { Network } from '@capacitor/network';

const isOnline = ref(true);

Network.getStatus().then((status) => {
  isOnline.value = status.connected;
});
Network.addListener('networkStatusChange', (status) => {
  isOnline.value = status.connected;
});

export function useConnectivity() {
  return { isOnline };
}
